import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TasaPorTarjetaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TASA' htmlFor='input-tasaPorTarjeta' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tasaPorTarjeta'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-tasaPorTarjeta'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TasaPorTarjetaFormGroup)
